export function getSalesforceInstanceUrl() {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const init = {headers: headers, credentials: 'include'};

	return fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'salesforce/instance_url', init)
		.then(result => result.json())
		.then(response => response);
}
